export enum ReviewType {
  Unknown,
  Claims,
}

export const displayReadableReviewType = (value: ReviewType) => {
  switch (value) {
    case ReviewType.Claims:
      return 'Claims';
  }
};
